import { DataTable, Heading, Text, VFlow } from 'bold-ui'
import { DimensaoProcedimento, HistoricoDimensaoProcedimentoFragment } from 'graphql/types.generated'
import { historicoSubsectionStyles } from 'view/atendimentos/detail/historico/model/model-historico'

interface HistoricoExamesSolicitadosDwTableProps {
  exames: ReadonlyArray<HistoricoDimensaoProcedimentoFragment>
}

export const HistoricoExamesSolicitadosDwTable = ({ exames }: HistoricoExamesSolicitadosDwTableProps) => (
  <VFlow vSpacing={0.5}>
    <Heading level={5} style={historicoSubsectionStyles.plano}>
      Exames solicitados
    </Heading>
    <DataTable<HistoricoDimensaoProcedimentoFragment>
      rows={exames.toSorted((a, b) => a.descricaoProcedimento.localeCompare(b.descricaoProcedimento))}
      columns={[
        {
          name: 'nome',
          header: 'Nome',
          render: renderExameSolicitado,
        },
      ]}
    />
  </VFlow>
)

const renderExameSolicitado = (item: DimensaoProcedimento) => (
  <Text>
    {item.descricaoProcedimento} - {item.codigoProcedimento}
  </Text>
)
